import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { LogService } from './log.service';
import { UserService } from './user.service';
import { File360Error } from './error.model';

export const enum HttpStatus {
  ConnectionRefused = 0,
  Unauthorized = 401,
};

@Injectable({
  providedIn: 'root'
})

export class ErrorHandlerUnauthorizedService {

  constructor(private log: LogService, private user: UserService, private router: Router) { }

  handleError(error: any): boolean {
    if (error.error instanceof HttpErrorResponse) {
      let f360err: File360Error = new File360Error(error.status, error.error, error);
      this.log.logError(f360err);
      if (error.status == HttpStatus.Unauthorized) {
        if (this.user.lastErrorMessage == undefined || this.user.lastErrorMessage.length == 0) {
          this.user.lastErrorMessage = f360err.Message;
          this.user.redirectUrl = window.location.pathname;
          this.router.navigate(['/']);
          return true;
        }
        else
          return true;
      }
    } else if (error instanceof HttpErrorResponse) {
      let f360err: File360Error = new File360Error(error.status, error.error, error);
      this.log.logError(f360err);
      if (error.status == HttpStatus.Unauthorized) {
        if (this.user.lastErrorMessage == undefined || this.user.lastErrorMessage.length == 0) {
          this.user.lastErrorMessage = f360err.Message;
          this.user.redirectUrl = window.location.pathname;
          this.router.navigate(['/']);
          return true;
        }
        else
          return true;
      }
    } else if (error instanceof File360Error) {
      this.log.logError(error);
      if (error.Id == HttpStatus.Unauthorized) {
        if (this.user.lastErrorMessage == undefined || this.user.lastErrorMessage.length == 0) {
          this.user.lastErrorMessage = error.Message;
          this.user.redirectUrl = window.location.pathname;
          this.router.navigate(['/']);
          return true;
        }
        else
          return true;
      }
    } else if (error.response instanceof HttpErrorResponse) {
      this.log.logError(error.response);
      if (error.response.status == HttpStatus.Unauthorized) {
        if (this.user.lastErrorMessage == undefined || this.user.lastErrorMessage.length == 0) {
          this.user.lastErrorMessage = error.response.error;
          this.user.redirectUrl = window.location.pathname;
          this.router.navigate(['/']);
          return true;
        }
        else
          return true;
      }
    }
    return false;
  }
}
